import { Text } from '@/ui-kit'
import { StakingInterface } from './components/StakingInterface'

const StakeSOL = () => {
  return (
    <>
      <Text type="h4" className="py-8">
        Stake SOL and Receive $DATA Airdrop
      </Text>
      <StakingInterface />
    </>
  )
}

export default StakeSOL
